import { useTranslation } from "react-i18next";
import { Widget } from "datastake-daf/dist/components";
import Style from "./style";
import { config } from './config';

export default function DataSettingsWidget({ data = {}, loading }) {
  const { t } = useTranslation();

  return (
    <Widget
      title={t('Data Settings')}
      loading={loading}
      className="with-border-header custom-width-b h-w-btn-header"
    >
      <Style>
        {config.map((conf) => (
          <div className="conf-row" key={conf.key}>
            <label>{t(conf.label)}</label>
            <label className="value">
              {t(data[conf.key] || '-')}
            </label>
          </div>
        ))}
      </Style>
    </Widget>
  );
}
